import AdminLayout from '@/components/AdminLayout/index.vue'

const adminRoutes = [
  {
    path: '/admin',
    component: AdminLayout,
    redirect: '/admin/dashboard',
    meta: {},
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: () => import('@/views/admin/Dashboard/index.vue'),
        meta: { title: '仪表盘' }
      },
      {
        path: 'employees',
        name: 'EmployeeManager',
        component: () => import('@/views/admin/EmployeeManager/index.vue'),
        meta: { title: '员工列表' }
      },
      {
        path: 'salary-manage',
        name: 'SalaryManage',
        component: () => import('@/views/admin/SalaryManage/index.vue'),
        meta: { title: '薪资管理' }
      },
      {
        path: 'appraisal/settings',
        name: 'AppraisalSettings',
        component: () => import('@/views/admin/Appraisal/Settings/index.vue'),
        meta: { title: '考核设置' }
      },
      {
        path: 'appraisal/records',
        name: 'AppraisalRecords',
        component: () => import('@/views/admin/Appraisal/Records/index.vue'),
        meta: { title: '考核管理' }
      },
      {
        path: 'appraisal/stats',
        name: 'AppraisalStats',
        component: () => import('@/views/admin/Appraisal/Stats/index.vue'),
        meta: { title: '考核统计' }
      },
      {
        path: 'system-settings/column-config',
        name: 'ColumnConfig',
        component: () => import('@/views/admin/ColumnConfig/index.vue'),
        meta: { title: '列配置' }
      },
      {
        path: 'salary-dashboard',
        name: 'SalaryDashboard',
        component: () => import('@/views/admin/SalaryDashboard/index.vue'),
        meta: { title: '工资条仪表盘' }
      },
      {
        path: 'salary-upload',
        name: 'SalaryUpload',
        component: () => import('@/views/admin/SalaryUpload/index.vue'),
        meta: { title: '上传工资表' }
      },
      {
        path: 'upload-history',
        name: 'UploadHistory',
        component: () => import('@/views/admin/UploadHistory/index.vue'),
        meta: { title: '工资条管理' }
      },
      {
        path: 'salary-send',
        name: 'SalarySend',
        component: () => import('@/views/admin/SalarySend/index.vue'),
        meta: { title: '工资条查看' }
      },
      {
        path: 'salary-records',
        name: 'SalaryRecordList',
        component: () => import('@/views/admin/SalaryRecordList/index.vue'),
        meta: { title: '工资记录' }
      },
      {
        path: 'clients',
        name: 'ClientManager',
        component: () => import('@/views/admin/ClientManager/index.vue'),
        meta: { title: '单位管理' }
      },
      {
        path: 'projects',
        name: 'ProjectManager',
        component: () => import('@/views/admin/ProjectManager/index.vue'),
        meta: { title: '项目管理' }
      },
      {
        path: 'project-dashboard',
        name: 'ProjectDashboard',
        component: () => import('@/views/admin/ProjectDashboard/index.vue'),
        meta: { title: '项目仪表盘' }
      },
      {
        path: 'project-payments',
        name: 'ProjectPayment',
        component: () => import('@/views/admin/ProjectPayment/index.vue'),
        meta: { title: '项目收款' }
      },
      {
        path: 'project-settlements',
        name: 'ProjectSettlement',
        component: () => import('@/views/admin/ProjectSettlement/index.vue'),
        meta: { title: '项目结算' }
      },
      {
        path: 'partner-settlements',
        name: 'PartnerSettlement',
        component: () => import('@/views/admin/PartnerSettlement/index.vue'),
        meta: { title: '合伙人结算' }
      },
      {
        path: 'finance/dashboard',
        name: 'FinanceDashboard',
        component: () => import('@/views/admin/FinanceDashboard/index.vue'),
        meta: { title: '财务仪表盘' }
      },
      {
        path: 'finance/income-vouchers',
        name: 'IncomeVoucher',
        component: () => import('@/views/admin/Finance/IncomeVoucher/index.vue'),
        meta: { title: '收入单' }
      },
      {
        path: 'finance/expense-vouchers',
        name: 'ExpenseVoucher',
        component: () => import('@/views/admin/Finance/ExpenseVoucher/index.vue'),
        meta: { title: '支出单' }
      },
      {
        path: 'finance/transfer-vouchers',
        name: 'TransferVoucher',
        component: () => import('@/views/admin/Finance/TransferVoucher/index.vue'),
        meta: { title: '转账单' }
      },
      {
        path: 'finance/fund-accounts',
        name: 'FundAccount',
        component: () => import('@/views/admin/Finance/FundAccount/index.vue'),
        meta: { title: '资金账户' }
      },
      {
        path: 'finance/categories',
        name: 'FinanceCategory',
        component: () => import('@/views/admin/Finance/FinanceCategory/index.vue'),
        meta: { title: '收支项目' }
      },
      {
        path: 'finance/partners',
        name: 'FinancePartner',
        component: () => import('@/views/admin/Finance/FinancePartner/index.vue'),
        meta: { title: '往来单位' }
      },
      {
        path: 'finance/other-records',
        name: 'FinanceOtherRecord',
        component: () => import('@/views/admin/Finance/OtherRecord/index.vue'),
        meta: { title: '其他记录' }
      },
      {
        path: 'company/overview',
        name: 'CompanyOverview',
        component: () => import('@/views/admin/company/CompanyDocOverview.vue'),
        meta: { title: '企业资料概览' }
      },
      {
        path: 'company/qualifications',
        name: 'CompanyQualifications',
        component: () => import('@/views/admin/company/CompanyDocList.vue'),
        props: { category: 'qualification' },
        meta: { title: '企业资质证照', componentName: 'CompanyDocList' }
      },
      {
        path: 'company/licenses',
        name: 'CompanyLicenses',
        component: () => import('@/views/admin/company/CompanyDocList.vue'),
        props: { category: 'license' },
        meta: { title: '银行/税务/印章证照', componentName: 'CompanyDocList' }
      },
      {
        path: 'company/iprs',
        name: 'CompanyIprs',
        component: () => import('@/views/admin/company/CompanyDocList.vue'),
        props: { category: 'ipr' },
        meta: { title: '知识产权证书' }
      },
      {
        path: 'company/accounts',
        name: 'CompanyAccounts',
        component: () => import('@/views/admin/company/CompanyDocList.vue'),
        props: { category: 'account' },
        meta: { title: '企业账号管理', componentName: 'CompanyDocList' }
      },
      {
        path: 'company/contracts',
        name: 'CompanyContracts',
        component: () => import('@/views/admin/company/CompanyDocList.vue'),
        props: { category: 'contract' },
        meta: { title: '行政合同&模板库', componentName: 'CompanyDocList' }
      },
      {
        path: 'company/project-contracts',
        name: 'CompanyProjectContracts',
        component: () => import('@/views/admin/company/CompanyDocList.vue'),
        props: { category: 'project_contract' },
        meta: { title: '项目合同', componentName: 'CompanyDocList' }
      },
      {
        path: 'company/general',
        name: 'CompanyGeneral',
        component: () => import('@/views/admin/company/CompanyDocList.vue'),
        props: { category: 'general' },
        meta: { title: '通用资料', componentName: 'CompanyDocList' }
      },
      {
        path: 'approval/types',
        name: 'ApprovalTypes',
        component: () => import('@/views/admin/Approval/ApprovalTypes/index.vue'),
        meta: { title: '申请类型' }
      },
      {
        path: 'approval/flows',
        name: 'ApprovalFlows',
        component: () => import('@/views/admin/Approval/ApprovalFlows/index.vue'),
        meta: { title: '审批流管理' }
      },
      {
        path: 'approval/center',
        name: 'ApprovalCenter',
        component: () => import('@/views/admin/Approval/ApprovalCenter/index.vue'),
        meta: { title: '申请办理' }
      },
      {
        path: 'approval/comp',
        name: 'ApprovalComp',
        component: () => import('@/views/admin/Approval/ApprovalComp/index.vue'),
        meta: { title: '调休余额' }
      },
      {
        path: 'approval/leave',
        name: 'LeaveQuota',
        component: () => import('@/views/admin/Approval/LeaveQuota/index.vue'),
        meta: { title: '假期额度' }
      },
      {
        path: 'system-settings/email',
        name: 'SystemSettings',
        component: () => import('@/views/admin/SystemSettings/index.vue'),
        meta: { title: '邮箱配置' }
      },
      {
        path: 'system-settings/work-time',
        name: 'WorkTimeSettings',
        component: () => import('@/views/admin/SystemSettings/WorkTime/index.vue'),
        meta: { title: '工作时长设置' }
      },
      {
        path: 'system-settings/employee-menus',
        name: 'EmployeeMenuSettings',
        component: () => import('@/views/admin/SystemSettings/EmployeeMenus/index.vue'),
        meta: { title: '员工端菜单' }
      },
      {
        path: 'system-settings/organization',
        name: 'OrganizationManage',
        component: () => import('@/views/admin/SystemSettings/Organization/index.vue'),
        meta: { title: '组织管理' }
      },
      {
        path: 'system-settings/announcements',
        name: 'AnnouncementManage',
        component: () => import('@/views/admin/SystemSettings/Announcement/index.vue'),
        meta: { title: '通知管理' }
      },
      {
        path: 'system-settings/holiday',
        name: 'HolidayManage',
        component: () => import('@/views/admin/HolidayManage/index.vue'),
        meta: { title: '假期管理' }
      },
      {
        path: 'system-settings/feedback',
        name: 'FeedbackManage',
        component: () => import('@/views/admin/SystemSettings/Feedback/index.vue'),
        meta: { title: '问题反馈' }
      },
      {
        path: 'system-settings/login-logs',
        name: 'LoginLogs',
        component: () => import('@/views/admin/LoginLogs/index.vue'),
        meta: { title: '登录日志' }
      },
      {
        path: 'system-settings/operation-logs',
        name: 'OperationLogs',
        component: () => import('@/views/admin/OperationLogs/index.vue'),
        meta: { title: '操作日志' }
      },
      {
        path: 'system-settings/roles',
        name: 'RoleManager',
        component: () => import('@/views/admin/RoleManager/index.vue'),
        meta: { title: '角色管理' }
      },
      {
        path: 'system-settings',
        name: 'SystemSettingsRoot',
        redirect: '/admin/system-settings/email',
        meta: { title: '系统设置' }
      }
    ]
  }
]

export default adminRoutes
